import { httpGet, httpPost } from "@/request/http";

export default {
  get() {
    return httpGet("employee/authority-shortcuts");
  },
  post(items) {
    return httpPost("employee/authority-shortcuts", items);
  },
};
